const VALUES = [
  { n: "01", t: "Senior on every seat", d: "No juniors on production critical paths. Every consultant has 12+ years of platform experience." },
  { n: "02", t: "Deliverables, not hours", d: "We contract to artifacts: pipelines, dashboards, models. You see what you're paying for." },
  { n: "03", t: "Tool-pragmatic", d: "We are platform-fluent, not platform-religious. The tool serves the outcome." },
  { n: "04", t: "Auditable impact", d: "Every engagement closes with a measurement plan tied to your P&L." },
];

const About = () => (
  <>
    <section className="bg-[#0a0a0a] text-white grain relative overflow-hidden" data-testid="about-hero">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#0055FF]/10 blur-[160px] rounded-full" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-24 pb-20 relative grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-8">
          <p className="text-xs tracking-[0.25em] uppercase text-white/40 mb-6">About</p>
          <h1 className="font-display text-[clamp(2.5rem,7vw,7rem)] leading-[0.88] tracking-tighter">
            A senior bench. <br />A short rope. <br />
            <span className="text-[#0055FF]">No surprises.</span>
          </h1>
        </div>
        <div className="col-span-12 md:col-span-4 md:pl-8 md:border-l md:border-white/10 self-end">
          <p className="text-white/70 leading-relaxed">
            Pragma was founded by a BI engineer who grew tired of watching
            six-figure salary programs stall in slideware. He set out to
            give businesses a way to use real-time, practical data to make
            solid decisions — engineered into production, not stuck in a deck.
          </p>
        </div>
      </div>
    </section>

    {/* Image row */}
    <section className="bg-[#0a0a0a]" data-testid="about-image">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div
          className="aspect-[21/9] w-full bg-cover bg-center border border-white/10"
          style={{
            backgroundImage:
              "linear-gradient(to bottom, rgba(10,10,10,0.4), rgba(10,10,10,0.7)), url(https://images.pexels.com/photos/8297845/pexels-photo-8297845.jpeg)",
          }}
        />
      </div>
    </section>

    {/* Values */}
    <section className="bg-white text-[#09090b]" data-testid="about-values">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-4">
          <p className="text-xs tracking-[0.25em] uppercase text-zinc-500 mb-6">Principles</p>
          <h2 className="font-display text-5xl tracking-tighter leading-[0.95]">
            Four rules <br />we don't bend.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-8">
          <div className="border-t border-black/10">
            {VALUES.map((v) => (
              <div key={v.n} className="py-8 border-b border-black/10 grid grid-cols-12 gap-6 items-baseline">
                <span className="col-span-2 md:col-span-1 text-xs text-zinc-400 tabular-nums">{v.n}</span>
                <h3 className="col-span-10 md:col-span-4 font-display text-2xl tracking-tight">{v.t}</h3>
                <p className="col-span-12 md:col-span-7 text-zinc-600 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default About;
